import gql from 'graphql-tag';
import { compose } from 'ramda';

import { selectParams } from '#src/store/location/selectors';
import { setInvite } from '#src/store/content/actions';
import { toNotFound } from '#src/store/location/actions';
import { baseImageGraphqlFields } from '#src/lib/wb-asset/image-graphql-fields';

const query = gql`
  query AccountabilityInvite($token: String) {
    invite(token: $token) {
      id
      token
      creditAmountCents
      gameId
      game {
        id
        betAmount
        displayCategory
        title
        image {
          ${baseImageGraphqlFields}
        }
      }
      userId
      user {
        id
        firstName
        displayName
        avatarV2 {
          value
          type
        }
      }
    }
  }
`;

export const path = '/accountability/:inviteToken';
export const component = 'InviteAccountabilityLanding';
export const thunk =
  ({ graphqlClient }) =>
  async (dispatch, getState) => {
    const { inviteToken } = selectParams(getState());
    const { data } = await graphqlClient.query({
      query,
      fetchPolicy: 'network-only',
      variables: { token: inviteToken },
    });

    const { invite } = data || {};
    if (!invite) {
      dispatch(toNotFound());
      return;
    }
    compose(dispatch, setInvite)(invite);
  };
